export default "__VITE_ASSET__afbe6de9__"